import angular from 'angular'

import MapSimple from '../utils/map-simple'
import StrictObj from '../utils/strict-obj'
import extractRawElm from '../utils/extract-raw-elm'

import { trim } from '../utils/bits'
import { getElmStr } from '../utils/get-elm-str'
import { escapeHtml } from '../utils/security'

const VALUE_RE = /^%{\w+}$/
const VALUES_RE = /(\s*)(%{\w+})(\s*)/g

angular
  .module('ggs.tmpl')
  .factory('tmplMap', TmplMapProvider)
  .directive('ggsTmpl', TmplDirective)
  .directive('ggsTmplValueFor', TmplValueForDirective)

function TmplMapProvider() {
  return MapSimple()
}

function TmplDirective($log, $parse, tmplMap) {
  return {
    restrict: 'A',
    link($scope, $elm, $attr) {
      const elm = extractRawElm($elm)
      const bits = []

      const regsIndex = tmplMap.getIndex(elm)
      const regs = tmplMap.getByIndex(regsIndex)
      tmplMap.delByIndex(regsIndex)

      const ngExp = $parse($attr.ggsTmpl)
      const initValue = ngExp($scope)
      if (ngExp.oneTime && (initValue !== undefined)) {
        applyTmpl(initValue)
      } else {
        $scope.$watch(ngExp, applyTmpl)
      }

      function applyTmpl(tmpl) {
        for (let index = bits.length - 1; index !== -1; index--) {
          const bit = bits[index]
          bit.$scope.$destroy()
          bits.splice(index, 1)
        }

        const safeTmpl = escapeHtml(tmpl)
        const naiveHtml = '<span>' + safeTmpl.replace(VALUES_RE, '</span><span>$1</span><span>$2</span><span>$3</span><span>') + '</span>'
        const unspanHtml = naiveHtml.replace(/<span><\/span>\s*<span>/gi, '<span>').replace(/<\/span>\s*<span><\/span>/gi, '</span>')
        elm.innerHTML = unspanHtml

        let placeholders = 0
        let values = 0

        for (let index = elm.children.length - 1; index !== -1; index--) {
          const childElm = elm.children[index]
          const childText = trim(childElm.textContent)
          if (!VALUE_RE.test(childText)) {
            continue
          }

          placeholders++
          for (const reg of regs) {
            if (reg.valueFor === childText) {
              values++
              reg.$transclude(($elm, $scope) => {
                elm.insertBefore(extractRawElm($elm), childElm)
                elm.removeChild(childElm)
                bits.push(StrictObj({ $elm, $scope }))
              })
              break
            }
          }
        }

        if (placeholders !== values) {
          $log.warn(`Tmpl: [tmpl=${tmpl}] contains ${placeholders} placeholders but only ${values} values are found in ${getElmStr(elm)}`)
        }
      }
    }
  }
}

function TmplValueForDirective(tmplMap) {
  return {
    multiElement: true,
    transclude: 'element',
    priority: 600,
    terminal: true,
    restrict: 'A',
    $$tlb: true,
    link(_$scope, $elm, $attr, _$ctrl, $transclude) {
      const parentElm = extractRawElm($elm.parent())
      const parentIndex = tmplMap.getIndex(parentElm)
      const parentRegs = parentIndex !== -1
        ? tmplMap.getByIndex(parentIndex)
        : tmplMap.set(parentElm, [])

      const valueFor = $attr.ggsTmplValueFor

      parentRegs.push(StrictObj({
        valueFor,
        $elm,
        $transclude
      }))
    }
  }
}
